import { createApp, h } from 'vue'
import NaiveCheckboxMount from './components/NaiveCheckboxMount.vue'

function mountCheckbox(input: HTMLInputElement) {
    const container = document.createElement('div')
    input.replaceWith(container)

    const app = createApp({
        render() {
            return h(NaiveCheckboxMount, {
                checked: input.checked,
                value: input.value,
                name: input.name,
                id: input.id,
                disabled: input.disabled,
                required: input.required,
                ariaDescribedby: input.getAttribute('aria-describedby') ?? undefined,
                ariaLabelledby: input.getAttribute('aria-labelledby') ?? undefined,
                className: input.className
            })
        }
    })

    app.mount(container)
}

const selector = '.nf-field-container input[type="checkbox"]:not(.vue-replaced)'
// Initial scan
document.querySelectorAll<HTMLInputElement>(selector).forEach(mountCheckbox)

// Watch for dynamically added checkboxes
const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
        mutation.addedNodes.forEach(node => {
            if (node instanceof HTMLElement) {
                const inputs = node.matches(selector)
                    ? [node as HTMLInputElement]
                    : Array.from(node.querySelectorAll<HTMLInputElement>(selector))

                inputs.forEach(input => {
                    if (!input.dataset.vueMounted) {
                        input.dataset.vueMounted = 'true'
                        mountCheckbox(input)
                    }

                    // setTimeout(() => {
                    //     observer.disconnect()
                    // })
                })
            }
        })
    }
})

observer.observe(document.body, {
    childList: true,
    subtree: true
})
